import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../../../components/dashboard-layout/layout";
import ViewDetailsComponent, {
  TopicType,
  ViewTopic,
} from "../../../components/view-details.component";
import {
  AlertType,
  useDashboardStore,
} from "../../dashboard/store/dashboard.store";
import { getBirthPageById } from "../apis/birth-page.api";
import DeletePastPageDialog from "../dialogs/delete-birth-page.dialog";
import EditPastPageDialog from "../dialogs/edit-birth-page.dialog";
import { BirthPageDetailsEntity } from "../entities/birth-page-details.entity";
import { BirthPageDetailsModel } from "../models/birth-page-details.model";

const topics: ViewTopic[] = [
  {
    title: "Cover Image",
    contentKey: "imageUrl",
    type: TopicType.image,
  },
  {
    title: "Head Line",
    contentKey: "headLine",
    type: TopicType.string,
  },
  {
    title: "Description",
    contentKey: "description",
    type: TopicType.string,
  },
  {
    title: "Created At",
    contentKey: "createdAt",
    type: TopicType.dateTime,
  },
  {
    title: "Last Update",
    contentKey: "updatedAt",
    type: TopicType.dateTime,
  },
];

export default function ViewBirthPage() {
  const [searchParams] = useSearchParams();
  const [birthPage, setBirthPage] = useState<BirthPageDetailsEntity>();
  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const initEffect = useRef<boolean>(false);
  const setAlert = useDashboardStore((state) => state.setAlert);

  useEffect(() => {
    if (initEffect.current === false) {
      const id = searchParams.get("id");
      if (id) {
        getBirthPageById(id)
          .then((response) => {
            const newPastPage = new BirthPageDetailsModel(
              response.data
            ).toEntity();
            setBirthPage(newPastPage);
          })
          .catch((error) => {
            setAlert({
              message: error.response.data.message,
              type: AlertType.error,
            });
          });
      }
    }
    return () => {
      initEffect.current = true;
    };
  }, [searchParams, setAlert]);

  return (
    <Layout>
      {birthPage && (
        <EditPastPageDialog
          open={editModalOpen}
          setOpen={setEditModalOpen}
          birthPage={birthPage}
        />
      )}
      {birthPage && (
        <DeletePastPageDialog
          open={deleteModalOpen}
          setOpen={setDeleteModalOpen}
          birthPage={birthPage}
        />
      )}
      <div className="flex">
        <div className="flex-grow px-4 sm:px-0">
          <h3 className="text-base font-semibold leading-7 text-gray-900">
            Birth Page Details
          </h3>
        </div>
        <button
          className="mx-1 rounded-md bg-indigo-600 px-3 py-1.5 text-center text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={() => setEditModalOpen(true)}
        >
          Edit
        </button>
        <button
          className="mx-1 rounded-md bg-red-600 px-3 py-1.5 text-center text-sm font-semibold leading-6 text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={() => setDeleteModalOpen(true)}
        >
          Delete
        </button>
      </div>

      {birthPage && (
        <ViewDetailsComponent topics={topics} content={birthPage} />
      )}
    </Layout>
  );
}
